import { cn } from '~/chords/lib/cn';
import { variants } from '~/chords/lib/variants';

export const chevron = variants({
  base: cn('transform duration-300'),
  variants: {
    state: {
      default: cn('rotate-0'),
      open: cn('rotate-180'),
    },
  },
});

export const DROPDOWN_TRIGGER_CLEAR_BUTTON_CLASS = cn(
  'absolute right-[2.25rem] top-1/2 -translate-y-1/2',
  'opacity-none text-default',
  'transition-all delay-0 duration-100 ease-out peer-hover:delay-200',
  'hover:opacity-full peer-hover:opacity-full',
  'focus-visible:opacity-full',
  'size-xl items-center justify-center rounded-full p-xs',
  'hover:bg-emphasis-strong',
  'pointer-events-none',
  'group-hover/dropdown-trigger:animate-dropdown-delay-clear',
  'group-focus-within/dropdown-trigger:animate-dropdown-delay-clear',
);

export const DROPDOWN_OPTION_CLEAR_CLASS = cn(
  'flex min-h-[36px] w-full cursor-pointer items-center gap-sm px-md text-body-sm text-default',
  'transition-colors duration-300 hover:bg-emphasis-strong focus:outline-none focus:bg-emphasis-strong',
);
